import React, { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
//primeReact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Tooltip } from "primereact/tooltip";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { confirmDialog } from "primereact/confirmdialog";
//components
import { queryClient } from "../../../../../utils/queryClient";
import NumberInput from "../../../../../components/input/NumberInput";
//services
import { getFinancingRate } from "../../../../../services/Settings/Simulator/getFinancingRate";
import { postFinancingRate } from "../../../../../services/Settings/Simulator/postFinancingRate";
import { deleteFinancingRate } from "../../../../../services/Settings/Simulator/deleteFinancingRate";
import { useAppContext } from "../../../../../context/AppContext";

const Tax = ({ setActiveIndex }) => {
  const { id } = useParams();
  const { permissions } = useAppContext();

  const form = useForm();
  const errors = form.formState.errors;

  const [loadingButton, setLoadingButton] = useState(false);

  const columns = [
    { field: "percentage", header: "% Taxa" },
    { field: "max_installments", header: "Máximo Parcelas" },
  ];
  // get
  const { data: dataFinancingRate, isLoading: isLoadingFinancingRate } =
    useQuery("dataFinancingRate", () => getFinancingRate(id), {
      enabled: !!permissions?.includes("88"),
    });
  // post
  const { mutateAsync: postFinancingRateFn } = useMutation({
    mutationFn: postFinancingRate,
    onSuccess(data, variables) {
      //      console.log("Mutação bem-sucedida! Resultado:", data);
      variables.id = data.data.id;
      //      console.log("VARIABLES", variables);
      queryClient.setQueryData(["dataFinancingRate"], (data) => {
        //        console.log("DATA", data);
        return [...data, variables];
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  const onSubmitRate = async (data) => {
    setLoadingButton(true);
    const notification = toast.loading(
      "Gravando sua nova taxa de financiamento..."
    );

    data.enterprise_id = parseInt(id);
    const variables = {
      ...data,
    };
    try {
      await postFinancingRateFn(variables);
      setLoadingButton(false);
      toast.update(notification, {
        render: "Taxa cadastrada com sucesso",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      form.reset();
      return;
    } catch (err) {
      toast.update(notification, {
        render: err.response.data.error
          ? err.response.data.error
          : "Ocorreu um erro!",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
      form.reset();
      return err;
    }
  };
  // delete
  const { mutateAsync: financingRateDeleteFn } = useMutation({
    mutationFn: deleteFinancingRate,
    onSuccess(_, variables) {
      queryClient.setQueryData(["dataFinancingRate"], (data) => {
        const updatedData = data.filter((item) => item.id !== variables.id);
        return updatedData;
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  const removeOption = async (e, rowData) => {
    e.preventDefault();
    confirmDialog({
      message: "Você deseja deletar essa taxa?",
      header: "Confirmação",
      icon: "fa-solid fa-ban",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: async () => {
        setLoadingButton(true);
        const notification = toast.loading("Um momento, deletando taxa...");

        const id = rowData.id;

        const variables = {
          id,
        };

        try {
          await financingRateDeleteFn(variables);
          setLoadingButton(false);
          toast.update(notification, {
            render: "Taxa deletada com sucesso",
            autoClose: 1000,
            theme: "colored",
            type: "success",
            isLoading: false,
          });
          form.reset();
        } catch (err) {
          toast.update(notification, {
            render: "Houve um erro!",
            autoClose: 1000,
            theme: "colored",
            type: "error",
            isLoading: false,
          });
          setLoadingButton(false);
          form.reset();
          return err;
        }
      },
      reject: () => {
        return;
      },
    });
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  return (
    <div className="row">
      <form onSubmit={form.handleSubmit(onSubmitRate)}>
        <div className="row">
          <div className="col-md-5 my-2">
            <h3>
              {" "}
              Informe a Taxa de Juros Mensal
              <Tooltip target=".custom-target-icon" />
              <i
                className="custom-target-icon px-2 pi 
                      pi-info-circle p-text-secondary"
                data-pr-tooltip="Informe a taxa de juros (mensal) correspondente ao máximo de parcelas definida"
                style={{ cursor: "pointer" }}
              ></i>
            </h3>
            <NumberInput
              name="percentage"
              suffix="%"
              placeholder="0%"
              required={true}
              max={100}
              minFractionDigits={2}
              control={form.control}
              errors={errors}
              label="Taxa de Juros Mensal"
              getFormErrorMessage={getFormErrorMessage}
            />
          </div>
          <div className="col-md-5 my-2">
            <h3>
              {" "}
              Informe o Máximo de Parcelas
              <Tooltip target=".custom-target-icon" />
              <i
                className="custom-target-icon px-2 pi 
                          pi-info-circle p-text-secondary"
                data-pr-tooltip="Informe o máximo de parcelas correspondente a taxa de juros definida"
                style={{ cursor: "pointer" }}
              ></i>
            </h3>
            <NumberInput
              name="max_installments"
              max={1000}
              required={true}
              control={form.control}
              errors={errors}
              label="Máximo de Parcelas"
              getFormErrorMessage={getFormErrorMessage}
            />
          </div>
          <div className="col-md-2 pt-3">
            <div className="d-flex justify-content-center mt-5">
              <Button
                rounded
                type="submit"
                iconPos="right"
                label="Adicionar"
                loading={loadingButton}
                icon="fa-solid fa-plus"
                className="p-inputtext-sm m-auto"
              />
            </div>
          </div>
        </div>
      </form>
      {isLoadingFinancingRate && (
        <div className="col-md-12 text-end mt-3 my-auto">
          <Skeleton width="100%" height="180px" />
        </div>
      )}
      {!isLoadingFinancingRate && (
        <div className="row mt-4">
          <div className="px-2 pb-3">
            <DataTable
              rows={5}
              paginator
              stripedRows
              showGridlines
              sortMode="multiple"
              selectionMode="single"
              rowsPerPageOptions={[5, 25, 100]}
              value={
                dataFinancingRate &&
                dataFinancingRate.map((item) => {
                  if (item && item.percentage != null) {
                    return { ...item, percentage: `${item.percentage}%` };
                  }
                  return item;
                })
              }
              emptyMessage="Nenhuma Informação foi encontrada."
              tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
            >
              {columns.map((col) => (
                <Column
                  sortable
                  key={col.field}
                  field={col.field}
                  header={col.header}
                />
              ))}
              <Column
                header="Ações"
                body={(rowData) => (
                  <div className="text-center">
                    <button
                      className="btn btn-danger btn-btn-sm"
                      onClick={(e) => removeOption(e, rowData)}
                    >
                      <i className="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                )}
              />
            </DataTable>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tax;
